/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { styled } from '@mui/system';
import { Box, Divider } from '@mui/material';
import { buttonClasses } from '@mui/base/Button';
import Tabs from '@mui/base/Tabs';
import Tab, { tabClasses } from '@mui/base/Tab';
import TabsList from '@mui/base/TabsList';
import { tokens } from '../../../tokens';


const StyledTab = styled(Tab)`
  font-family: Roboto, Arial, sans-serif;
  color: ${tokens.token_text_grey_on_grey};
  cursor: pointer;
  font-size: 0.775rem;
  font-weight: 500;
  background-color: transparent;
  width: auto;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-right: 8px;
  padding-left: 8px;
  margin: 4px 4px;
  border: none;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  border-radius: 24px;
  border: 1px solid ${tokens.token_table_background};

  justify-content: center;

  &:hover {
    background-color: ${tokens.token_surface};
  }

  &:focus {
    color: ${tokens.token_red};
    outline: 1px solid ${tokens.token_table_bottom_border};
  }

  &.${tabClasses.selected} {
    background-color: ${tokens.token_grey_100};
    color: ${tokens.token_grey_900};
  }

  &.${buttonClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const StyledTabsList = styled(TabsList)(
  ({ theme }) => `
  min-width: 400px;
  background-color: ${tokens.token_surface};
  border: transparent;
  border-radius: 4px;
  margin-bottom: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
          
  `
);

export default function ModelTabs({ setSelectedAPIRoute }) {
  return (
    <Box
      sx={{
        maxWidth: '100%',
        my: 0.5,
        overflow: 'hidden',
        overflowX: 'scroll',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}
    >
      <Tabs
        defaultValue={0}
        aria-label="Tabs where selection follows focus"
        selectionFollowsFocus
      >
        <StyledTabsList>
          {/* <Tab onClick={() => setSelectedAPIRoute('General Model')}> */}
          <StyledTab>General QA</StyledTab>
          {/* <Tab onClick={() => setSelectedAPIRoute('Incident Report')}> */}
          <StyledTab disabled>Incident Report</StyledTab>
          {/* <Tab onClick={() => setSelectedAPIRoute('Fraud Detection')}> */}
          <StyledTab disabled>Fraud Detection</StyledTab>
          {/* <Tab onClick={() => setSelectedAPIRoute('Data Analytics')}> */}
          <StyledTab disabled>Data Analytics</StyledTab>
        </StyledTabsList>
      </Tabs>
    </Box>
  );
}
